// this class defines constants used across multiple directory components and methods 
export class Constants {
    static readonly NAME = "LastName";
    static readonly COUNTRY = "Country";
    static readonly STATE = "State";
    static readonly CITY = "City";
    static readonly ZIPCODE = "ZipCode";
    static readonly LANGUAGE = "Language";
    static readonly SPECIALTY = "Specialty";
    static readonly INTEREST = "Interest";
}